// extracted by mini-css-extract-plugin
module.exports = {"root":"mztly7","smartLinks":"FOQRZw","title":"GxFQ3Y","slider":"c7Fmhuj"};